<style scoped>
	.cus-item {
    border: 1px solid rgba(226, 226, 226, .5);
  }

  .item-title {
    background: rgba(234, 242, 255, 1);
    padding:0 30px;
    width: 100%;
    text-align: left;
    height: 100%;
    display: flex;
    justify-content: space-between;
  }
  .item-title-state{
    color:#0F7BD0;
  }

  .item-content-box {
    border-top: 1px solid rgba(226, 226, 226, 1);
    width: 100%;
  }

  .margin-30-lr {
    margin: 0 30px;
  }

  .item-params {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
  }

  .all-item-bottom-dashed {
    border-bottom: 1px #CCCCCC dashed;
    padding-bottom: 20px;
  }

  .item-params > .params {
    width: 300px;
    text-align: left;
    padding: 10px 0;
    color: #333333;
  }

  /*  item-pay-box  */
  .item-pay-p-title {
    text-align: left;
    margin: 20px 30px 0 30px !important;
  }

  .item-pay-box {
    display: flex;
    flex-wrap: wrap;
  }

  .item-pay-box > .my-item-pay {
    margin-right: 96px;
  }

  .item-pay-box > .my-item-pay:nth-child(3n) {
    margin-right: 0
  }

  /* *  btn  * */
  .item-btn-box {
    display: flex;
    padding: 20px 0 0 0;
  }

  .btn {
    width: 88px;
    height: 30px;
    line-height: 30px;
    margin-right: 10px;
    color: #666666;
    border: 1px solid rgba(204, 204, 204, 1);
    cursor: pointer;
    position: relative;
  }

  .blue-btn {
    background: linear-gradient(0deg, rgba(63, 159, 234, 1) 0%, rgba(10, 119, 206, 1) 100%);
    border: none;
    color: #ffffff;
  }

  .blue-border {
    border: 1px solid rgba(13, 122, 207, 1);
    color: #0D7ACF;
  }

  .btn-disabled {
    cursor: not-allowed;
  }
  /*btn-prover*/
  .btn-prover{
    position: absolute;
    top: -75px;
    left: 0;
    width: 88px;
    height: 105px;
    display: none;
  }
  .a123:hover .btn-prover{
    display: block;
  }

  .btn-prover>.btn-prover-content{
    height: 60px;
    box-shadow: 0 0 20px 2px #dcdfe6;
    border-radius: 5px;
    background: #FFFFFF;
  }
  .btn-prover>.btn-prover-content>.download:hover{
    color:#26AFFD;
  }
  .btn-prover>.third-icon{
    width: 0;
    height: 0;
    border-bottom: 5px solid transparent;
    border-top: 10px solid #ffffff;
    border-left: 5px solid transparent;
    border-right: 5px solid transparent;
    margin: -3px 0 0 10px;
  }
  /* contract-upload */

  .model-content{
    width: 400px;
    height: 400px;
    box-shadow: 0 0 20px 2px #999999;
    border-radius: 5px;
    background: #FFFFFF;
    margin-top: 150px;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
  }
  .content-content{
    flex: 1;
	margin-top: 30px;
  }
  .btn-button{
    margin: 10px 20px 20px 0;
    display: flex;
    justify-content: flex-end;
  }
  .inp{
  	width: 60% !important;
  	margin-left: 20px;
  }
  .t_title{
  	font-size: 16px;
  }
</style>

<!--
定制订单item组件
-->
<template>
	<div class="cus-item" :style="'margin:' + itemMargin + ';'">
		<el-collapse @change="handleChange">
			<el-collapse-item>
				<div class="item-title" ref="titlebarclick" slot="title">
					<span>{{time}} {{$t('order.number')}}：{{orderNo}}</span>
					<span class="item-title-state">
						{{
				orderState === 0 ? $t('state.toexamine')
			  : orderState === 1 ? $t('state.upload')
              : orderState === 2 ? $t('state.htToexamine')
              : orderState === 3 ? $t('state.setup')
              : orderState === 4 ? ($t('state.payment') +(send === 1 ? '（'+ $t('state.Shipped')+')' : ''))
              : (orderState === 5 && num == 5 && assFlag !== 1 &&  assFlag !== 3)? (send === 1 ? $t('state.Receipt') :$t('state.delivergoods'))
              : orderState === 6 ? $t('state.htreject')
              : orderState === 7 ? $t('state.ddreject')
              : orderState === 8 && num == 8 && assFlag !== 1 &&  assFlag !== 3 ? $t('state.Completed')
              : orderState === 9 ? $t('state.Cancelled')
			  : assFlag === 1 ? $t('order.exchange')
			  : assFlag === 3? $t('order.returngoods')
			  : assFlag === 1 && num == 10? $t('order.exchange')
			  : assFlag === 3 && num == 10? $t('order.returngoods')
			  : assFlag === 2 && num == 10? $t('order.hcomplete')
			  : assFlag === 4&& num == 10? $t('order.tcomplete')
			  : assFlag === 5 && num == 10? $t('order.Rejected'): $t('state.Completed')
            }}
					</span>
				</div>
				<div class="item-content-box">
					<div class="item-params margin-30-lr all-item-bottom-dashed">
						<div class="params">{{$t('customizedApply.productName')}}：{{orderDetail.productName}}</div>
						<div class="params">{{$t('customizedApply.indexRequirement')}}：{{orderDetail.indexRequirement}}</div>
						<div class="params">{{$t('customizedApply.qualityGrade')}}：{{orderDetail.qualityGrade}}</div>
						<div class="params">{{$t('customizedApply.sizeRequirement')}}：{{orderDetail.sizeRequirement}}</div>
						<div class="params">{{$t('customizedApply.demandQuantity')}}：{{orderDetail.demandQuantity}}</div>
						<div class="params">{{$t('customizedApply.weight')}}：{{orderDetail.weight}}</div>
						<div class="params">{{$t('customizedApply.deliveryCycle')}}：{{orderDetail.deliveryCycle}}</div>
						<div class="params">{{$t('customizedApply.installationMode')}}：{{orderDetail.installationMode}}</div>
						<div class="params">{{$t('customizedApply.useEnvironment')}}：{{orderDetail.useEnvironment}}</div>
						<div class="params">{{$t('customizedApply.otherProcessRequirements')}}：{{orderDetail.otherProcessRequirements}}</div>
						<div class="params">{{$t('customizedApply.detailedDescription')}}：{{orderDetail.detailedDescription}}</div>
						<div class="params"></div>
					</div>
					<!-- 分期付款面板  -->
					<p class="item-pay-p-title">{{$t('order.bystages')}}</p>
					<div class="item-pay-box margin-30-lr all-item-bottom-dashed">
						<PayItemInOrderItem v-for="(item , index) in payData" :count="index + 1" :time="item.payTime" :total="item.payAmount"
						 :ids="item.ids" :details="item.details" :index="index" :payok="item.amountState" :checked="item.checked" :key="index"
						 item-class="my-item-pay">
						</PayItemInOrderItem>
					</div>
					<!-- 底部button按钮 -->
					<div class="item-btn-box margin-30-lr" @click="btnClick($event)">
						<div v-if="orderState == 9 || orderState == 8" class="btn" @click="deleteOrder">{{$t('order.deletes')}}</div>
						<div data-setval="0" v-if="unPayIndex > -1 && assFlag < 1 && orderState == 4" class="btn blue-btn">{{$t('order.payment')}}</div>
						<div data-setval="1" v-if="![4,5,8,9].includes(orderState) && assFlag < 1" class="btn blue-border">{{$t('order.Corder')}}</div>
						<div data-setval="2" class="btn" @click="det">{{$t('order.details')}}</div>
						<div data-setval="3" class="btn" v-if="(orderState === 5 || orderState === 8) && num !== 10 && nums !== payData.length"
						 @click="flag = true">{{$t('order.ApplyBilling')}}</div>
						<div data-setval="4" v-if="orderState === 1 || orderState === 6" class="btn blue-btn">{{$t('order.upcontract')}}</div>
						<div data-setval="5" class="btn blue-btn a123" v-if="assFlag < 1 && (backContract !== null || frontContract !== null)">
							<span>{{$t('order.Dcontract')}}</span>
							<div class="btn-prover" @click="e => e.cancelBubble = true">
								<div class="btn-prover-content">
									<a :href="backContract !== null?$img + backContract.split(',')[1]:''" data-setbtn="1" class="download"
									 download v-if="backContract !== null">{{$t('order.Gcontract')}}</a>
									<a :href="frontContract !== null?$img + frontContract.split(',')[1]:''" data-setbtn="2" class="download"
									 download v-if="frontContract !== null">{{$t('order.Ycontract')}}</a>
								</div>
								<div class="third-icon"></div>
							</div>
						</div>
						<div v-if="((orderState === 4 && send === 1) || orderState === 8) && assFlag == 0" class="btn blue-btn a123"
						 @click="dialogVisible = true">{{$t('order.Aftersales')}}</div>
						<div data-setval="5" class="btn blue-btn a123" v-if="send === 1 && assFlag == 0 && orderState !== 8" @click="confirmReceipt()">
							<span>{{$t('order.Confirmreceipt')}}</span>
						</div>
					</div>
					<!-- 上传合同的模态框 -->
					<ModelPop v-if="showModel">
						<div class="model-content">
							<!--content box-->
							<div class="content-content">
								<!-- 上传合同input -->
								<el-upload class="upload-demo" drag accept=".doc,.docx,.pdf" action="/" :limit="1" :on-exceed="moreThanFile"
								 :on-remove="() => file = null" :http-request="e => file = e.file ">
									<i class="el-icon-upload"></i>
									<div class="el-upload__text">{{$t('order.up')}}<em>{{$t('order.clickUp')}}</em></div>
									<div class="el-upload__tip" slot="tip">{{$t('order.upTxt')}}</div>
								</el-upload>
							</div>
							<!--底部按钮-->
							<div class="btn-button">
								<el-button type="primary" @click="fileUpload">{{$t('order.determine')}}</el-button>
								<el-button @click="() => showModel = false">{{$t('order.Cancel')}}</el-button>
							</div>
						</div>
					</ModelPop>
				</div>
			</el-collapse-item>
		</el-collapse>
		<!-- 	售后申请 -->
		<el-dialog :title="$t('order.Applysales')" :visible.sync="dialogVisible" width="30%">
			<div class="flex_center" style="margin-bottom: 10px;">
				<div class="t_tittle">{{$t('order.AftersalesType')}}:</div>
				<el-select v-model="value" :placeholder="$t('order.Pleaseselect')" class="inp" @change="type" clearable>
					<el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
					</el-option>
				</el-select>
			</div>
			<div class="flex_center">
				<div class="t_tittle">{{$t('order.AftersalesReason')}}:</div>
				<el-input type="textarea" :autosize="{ minRows: 2, maxRows: 4}" :placeholder="$t('order.input')" v-model="textarea"
				 class="inp">
				</el-input>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="dialogVisible = false">{{$t('order.Cancel')}}</el-button>
				<el-button type="primary" @click="determine">{{$t('order.determine')}}</el-button>
			</span>
		</el-dialog>
		<!-- 	开票 -->
		<el-dialog :title="$t('order.ApplyBilling')" :visible.sync="flag" width="35%" style="text-align: left;">
			<el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
				<el-form-item :label="$t('order.BillingType')" prop="resource" label-width="120px">
					<el-radio-group v-model="ruleForm.resource">
						<el-radio :label="$t('order.domesticBilling')"></el-radio>
						<el-radio :label="$t('order.abroadBilling')"></el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item :label="$t('order.periodsNum')" prop="type" label-width="120px">
					<el-checkbox-group v-model="ruleForm.type">q
						<el-checkbox :label="$t('order.d')+Number(index+1)+$t('order.q')" name="type" v-for="(item,index) in payData"
						 @change="che(item.ids)" v-if="item.invoiceFlag === 0" :key="index"></el-checkbox>
					</el-checkbox-group>
				</el-form-item>
				<el-form-item :label="$t('order.corporatename')" prop="name" label-width="120px">
					<el-input v-model="ruleForm.name"></el-input>
				</el-form-item>
				<el-form-item :label="$t('order.taxpayer')" prop="num" label-width="120px">
					<el-input v-model="ruleForm.num"></el-input>
				</el-form-item>
				<el-form-item :label="$t('order.address')" prop="city" label-width="120px">
					<el-input v-model="ruleForm.city"></el-input>
				</el-form-item>
				<el-form-item :label="$t('order.tel')" prop="tel" label-width="120px">
					<el-input v-model="ruleForm.tel"></el-input>
				</el-form-item>
				<el-form-item :label="$t('order.OpeningName')" prop="kf_name" label-width="120px">
					<el-input v-model="ruleForm.kf_name"></el-input>
				</el-form-item>
				<el-form-item :label="$t('order.OpeningAccount')" prop="kf_num" label-width="120px">
					<el-input v-model="ruleForm.kf_num"></el-input>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" @click="submitForm('ruleForm')">{{$t('order.Applynow')}}</el-button>
				</el-form-item>
			</el-form>
		</el-dialog>
	</div>
</template>

<script>
	import PayItemInOrderItem from './PayItemInOrderItem';
	import ModelPop from '../../assembly/ModelPop';
	import utils from '../../../assets/js/utils';
	import {
		Loading
	} from 'element-ui';

	export default {
		name: "CustomizedOrderItem",
		components: {
			PayItemInOrderItem,
			ModelPop
		},
		props: {
			backContract: {
				type: String,
				default: ''
			},
			frontContract: {
				type: String,
				default: ''
			},
			num: {
				type: String,
				default: ''
			},
			assFlag: {
				type: Number,
				default: 0
			},
			itemMargin: {
				type: String,
				default: '30px 0'
			},
			time: {
				type: String,
				default: '0000-00-00'
			},
			orderNo: {
				type: String,
				default: ''
			},
			orderState: {
				type: Number,
				default: -1
			},
			send: {
				type: Number,
				default: 0
			},
			index: {
				type: Number,
				default: -1
			}
		},
		data() {
			return {
				flag: false,
				serviceType: "",
				textarea: "",
				options: [],
				value: '',
				dialogVisible: false,
				token: '',
				orderDetail: {},
				payData: [],
				componentLoad: false, //数据是否加载
				openOrClose: false, //是否下拉
				payItemCheckedArr: [],
				unPayIndex: -1,
				showModel: false,
				file: null,
				stages: [],
				nums: 0,
				ruleForm: {
					resource: '',
					name: '',
					num: "",
					city: "",
					tel: "",
					kf_name: "",
					kf_num: "",
					type: [],
				},
				rules: {}
			}
		},

		created() {
			this.options = this.$t('order.options')
			this.token = sessionStorage.getItem('token');
			this.rules = this.$t('order.rules')
		},
		methods: {
			// 删除订单
			deleteOrder(orderNo) {
				this.$confirm(this.$t('order.title'), this.$t('customizedApply.title'))
					.then(() => {
						this.$post('api/customized/order/del/order', {
							orderNo: this.orderNo,
							token: this.token
						}).then(res => {
							if (res.code === 0) {
								this.$message({
									type: 'success',
									message: this.$t('order.cancelOk')
								});
								//通知父组件修改订单状态
								this.$emit('update-state', {
									index: this.index,
									state: 'cancel'
								});
								return;
							}
						});
					})
					.catch(() => {
				
					});
			
			},
			// 确认收货
			confirmReceipt() {
				let that = this
				this.$post('api/customized/order/cancel', {
					orderNo: this.orderNo,
					state: 1,
					token: this.token
				}).then(res => {
					if (res.code === 0) {
						this.$message({
							type: 'success',
							message: this.$t('Tips.Receiptsuc')
						});
						that.$emit('update-state', {
							index: this.index,
							state: 'cancel'
						});
					}
				});
			},
			// 订单详情
			det() {
				this.$router.push(`/order/orderDetail?id=${this.orderNo}&num=${this.num}&type=1`);
			},
			che(e) {
				this.stages.push(e)
			},
			// 开票
			submitForm(formName) {
				this.$refs[formName].validate((valid, obj) => {
					if (valid) {
						let val = {
							name: this.ruleForm.name,
							num: this.ruleForm.num,
							city: this.ruleForm.city,
							tel: this.ruleForm.tel,
							kfhmc: this.ruleForm.kf_name,
							kfhzh: this.ruleForm.kf_num,
						}
						let url = '/api/invoice/apply'
						let data = {
							orderNo: this.orderNo,
							customizedIds: this.stages.join(','),
							invoiceType: this.ruleForm.resource == '国内开票' ? 1 : 2,
							orderType: 2,
							invoiceInfo: JSON.stringify(val),
							token: sessionStorage.getItem('token')
						}
						this.$post(url, data).then(res => {
							this.flag = false
							if (res.code == 0) {
								this.$message({
									message: this.$t('Tips.Billingsuc'),
									type: 'success'
								});
							} else {
								this.$message.error(res.msg);
							}
						});
					} else {
						return false;
					}
				});
			},
			// 售后类型
			type(e) {
				this.serviceType = e
			},
			// 确认售后
			determine() {
				if (this.serviceType == '') {
					this.$message({
						message:  this.$t('Tips.Aftersalestype'),
						type: 'warning'
					});
					return false
				}
				if (this.textarea == '') {
					this.$message({
						message: this.$t('Tips.Aftersalesdescription'),
						type: 'warning'
					});
					return false
				}
				let token = sessionStorage.getItem('token')
				let that = this;
				let url = `/api/back/service/add`;
				let data = {
					orderType: 2,
					orderNo: this.orderNo,
					questionContent: this.textarea,
					serviceType: this.serviceType,
					token: token
				}
				this.$post(url, data).then(res => {
					this.options = []
					this.textarea = ''
					this.dialogVisible = false
					if (res.code == 0) {
						this.$message({
							message: this.$t('Tips.applysuc'),
							type: 'success'
						});
					}
				});
			},
			//修改加载状态
			changeLoadState() {
				this.componentLoad = false;
			},
			//收起撑开的下拉
			closeAndOpen() {
				if (this.componentLoad && this.openOrClose) this.$refs.titlebarclick.click();
			},

			//自定义上传
			fileUpload() {
				let loading = Loading.service({
					lock: true,
					background: 'rgba(0, 0, 0, 0)',
					text: this.$t('customizedApply.uploadFile'),
				});
				let formData = new FormData();
				formData.append('file', this.file);
				formData.append('token', sessionStorage.getItem('token'));
				this.$fileUpload({
					url: '/open/upload/file',
					data: formData
				}).then(res => {
					//文件上传成功后提交其他数据
					loading.close();
					if (res.code === 0) {
						let url = res.data;
						//开始提交合同到后台
						this.$post('api/customized/order/upload/user/contract', {
							token: this.token,
							orderNo: this.orderNo,
							contractLink: this.file.name + ',' + url
						}).then(res1 => {
							if (res1.code === 0) {
								this.$message({
									type: 'success',
									message: this.$t('Tips.applysuc')
								});
								this.showModel = false;
								this.$emit('update-state', {
									index: this.index,
									state: 'contract'
								});
							}
						});
					}
				});
			},
			//文件超出限制个数时触发
			moreThanFile() {
				this.$message({
					type: 'warning',
					message: this.$t('Tips.upTips')
				})
			},
			//下载合同
			downloadContract(e) {
				let setbtn = e.target.dataset['setbtn'];
				setbtn = Number(setbtn);
				if (isNaN(setbtn)) return;
				switch (setbtn) {
					case 1:
						{
							if (!this.orderDetail.backContract) {
								this.$alert('合同未上传').catch(() => {});
								return;
							}
							//TODO 调用下载接口进行文件下载

						}
						break;
					case 2:
						{
							if (!this.orderDetail.frontContract) {
								this.$alert('合同未上传').catch(() => {});
								return;
							}
							//TODO 调用下载接口进行文件下载

						}
						break;
				}
				e.cancelBubble = true;
			},
			//防抖点击事件
			btnClick(e) {
				this.timer && clearTimeout(this.timer);
				this.timer = setTimeout(() => {
					this.timer = null;
					this.clickMethod(e)
				}, 300);
			},
			//事件判断
			clickMethod(e) {
				let val = Number(e.target.dataset['setval']);
				console.log(val, 'val');
				if (isNaN(val)) return;
				switch (val) {
					case 0:
						this.linkToPay();
						break;
					case 1:
						//取消订单
						this.cancelOrder();
						break;
					case 2:
						break;
					case 3:
						break;
					case 4:
						this.showModel = true;
						break;
				}
			},
			//立即付款的实现
			linkToPay() {
				let data = this.payData[this.unPayIndex];
				this.$confirm(this.$t('order.title'), this.$t('customizedApply.title')).then(() => {
					//组装数据传入支付页面
					let routerData = {
						payAmount: data.payAmount,
						orderNo: this.orderNo,
						pageName: this.$t('vip.customized'),
						orderType: 2 //定制订单
					};
					this.$emit('show-modal-fn');
					sessionStorage.setItem('paydatainfo', JSON.stringify(routerData));
					let routerLinkData = this.$router.resolve({
						path: '/payPage'
					});
					window.open(routerLinkData.href, '_blank');
				}).catch(res => {
					console.log(res, '取消支付');
				});
			},
			//取消订单实现
			cancelOrder() {
				this.$confirm(this.$t('order.Cancelpayment'), this.$t('customizedApply.title'))
					.then(() => {
						this.$post('api/customized/order/cancel', {
							orderNo: this.orderNo,
							state: 2,
							token: this.token
						}).then(res => {
							if (res.code === 0) {
								this.$message({
									type: 'success',
									message: this.$t('Tips.qxsuc')
								});
								//通知父组件修改订单状态
								this.$emit('update-state', {
									index: this.index,
									state: 'cancel'
								});
								return;
							}
							this.$message({
								type: 'danger',
								message: this.$t('project.cancelErr')
							});
						});
					}).catch(() => {

					});
			},

			handleChange() {
				this.openOrClose = !this.openOrClose;
				if (this.componentLoad) return;
				this.componentLoad = true;
				//加载数据
				this.handleChangeLoadData();
			},
			//加载数据
			handleChangeLoadData() {
				// request ==> 加载详情
				let url = 'api/customized/order/detail'
				let params = {
					orderNo: this.orderNo,
					token: this.token
				};
				this.$get(url,params).then(res => {
					if (res.code === 0) {
						this.orderDetail = res.data;
						return;
					}
					this.$message({
						type: 'success',
						message: '获取失败'
					});
				});
				let urls = 'api/customized/order/amount/list'
				let data = {
					orderNo: this.orderNo,
					token: this.token
				};
				//request ===> 加载分期数据
				this.$get(urls, data).then(res => {
					if (res.code === 0) {
						let data = res.data,
							payData = [];
						//组装第一期数据
						this.find1stPay(payData, data);
						this.payItemCheckedArr = new Array(payData.length);
						let unPayIndex = -1; //没支付的index
						payData.forEach((item, index) => {
							if (item.invoiceFlag === 1) {
								this.nums += 1
							}
							item.checked = false;
							if (item.amountState === 0 && unPayIndex === -1) {
								unPayIndex = index;
								this.unPayIndex = unPayIndex;
								item.checked = true;
							}
						});
						this.payData = payData;
					}
				});
			},
			//组装第一期数据
			find1stPay(payData = [], data = []) {
				let details = [],
					payAmount = 0,
					ids = '',
					amountState = 0,
					payTime = '',
					invoiceFlag = ''
				let payFlag = 0;
				//遍历第一期的详情
				data.forEach((item, index) => {
					if (item.headAmount === 1) {
						if (index === 0) payTime = utils.formatStringDate(item.amountTime, 'yyyy-MM-dd');
						amountState = item.amountState;
						ids += item.purchaseId + ',';
						payAmount += item.amount;
						invoiceFlag = item.invoiceFlag
						details.push({
							key: item.nameOfMoney,
							value: item.amount
						});
					} else {
						payData.push({
							details: [{
								key: item.nameOfMoney,
								value: item.amount
							}],
							payTime: utils.formatStringDate(item.amountTime, 'yyyy-MM-dd'),
							payAmount: item.amount,
							ids: item.purchaseId,
							amountState: item.amountState,
							invoiceFlag: item.invoiceFlag
						});
					}
				});
				if (payAmount <= 0) return;
				ids = ids.substring(0, ids.length - 1);
				payData.unshift({
					details,
					payTime,
					payAmount,
					ids,
					amountState,
					invoiceFlag
				})
			}
		}
	}
</script>



// WEBPACK FOOTER //
// src/components/memberCenter/order/CustomizedOrderItem.vue